import { copyAttributes, createAttributesObjectFromSource } from './attributes';

export const UtilsDOM = {
  copyAttributes,
  createAttributesObjectFromSource
};
